import * as THREE from 'three';
import getChromaKeyMaterial from './chromakey/ChromaKeyMaterial';
import { loadImageAsync } from '../utils/AssetLoader';

export default class VideoPlane {
    constructor(width, height, url, onVideoEnd, imageUrl = null, chromaColor = null, roomId = null, addToRenderLoop = null, videoReadyState) {
        if (typeof (width) !== 'number' || typeof (height) !== 'number') {
            throw new Error('width and height must be numbers!');
        }
        this.addToScene = this.addToScene.bind(this);
        this.removeFromScene = this.removeFromScene.bind(this);
        this.setTransform = this.setTransform.bind(this);
        this.setPosition = this.setPosition.bind(this);
        this.setRotation = this.setRotation.bind(this);
        this.play = this.play.bind(this);
        this.pause = this.pause.bind(this);
        this.end = this.end.bind(this);

        this.videoLoadedState = this.videoLoadedState.bind(this)
        this.isPlaying = this.isPlaying.bind(this);
        this.isVisible = this.isVisible.bind(this);

        this.imageUrl = imageUrl;
        this.image = null;
        if (imageUrl) {
            const imageGeometry = new THREE.PlaneGeometry(1, 1);
            const imageMaterial = new THREE.MeshBasicMaterial();
            this.image = new THREE.Mesh(imageGeometry, imageMaterial);
            this.image.visible = false;
            loadImageAsync(
                imageUrl,
                (image) => {
                    this.image.material.map = image;
                    this.image.material.needsUpdate = true;
                    this.image.material.transparent = true;
                    this.image.visible = true;
                },
                null,
                (error) => {
                    console.log("error: " + error + ", loading image with url: " + url);
                },
                roomId
            );
        }

        this.videoReadyState = videoReadyState;
        this.roomId = roomId
        this.onVideoEnd = onVideoEnd;
        this.video = document.createElement('video');
        this.video.src = url;
        this.video.crossOrigin = 'anonymous';
        this.video.setAttribute('webkit-playsinline', '');
        this.video.setAttribute('playsinline', '');
        this.video.currentTime = 1;
        this.video.playsInline = true;
        this.video.muted = true; 0
        this.video.load();
        if (this.videoReadyState) {
            this.video.currentTime = 0;
        } else {
            this.video.currentTime = 1;
        }
        this.video.addEventListener('ended', this.end, false);
        if (this.videoReadyState) {
            this.video.addEventListener('loadeddata', this.videoLoadedState, false)
        }

        const texture = new THREE.VideoTexture(this.video);
        texture.minFilter = THREE.LinearFilter;
        texture.magFilter = THREE.LinearFilter;
        texture.format = THREE.RGBFormat;

        const geometry = new THREE.PlaneGeometry(width, height);
        const material = chromaColor === null ? new THREE.MeshBasicMaterial({ side: THREE.FrontSide }) : getChromaKeyMaterial(texture, chromaColor);
        material.map = texture;
        material.needsUpdate = true;
        this.plane = new THREE.Mesh(geometry, material);
        this.plane.visible = false;
        this.plane.userData.isVideoPlane = true
        this.addToRenderLoop = addToRenderLoop;
    }

    videoLoadedState() {
        if (this.video && this.video.readyState === 4 && this.videoReadyState) {
            this.plane.visible = true;
            this.plane.userData.shouldBeVisible = true
            this.videoReadyState(true)
        }
    }

    addToScene(scene) {
        scene.add(this.plane);
        if (this.imageUrl) {
            scene.add(this.image);
        }
    }

    removeFromScene(scene) {
        scene.remove(this.plane);
        if (this.imageUrl) {
            scene.remove(this.image);
            this.image = null;
        }
        this.plane = null;
        this.pause();
        this.video = null;
    }

    setTransform(transform, imageTransform = null) {
        this.plane.matrix = transform;
        this.plane.matrix.decompose(this.plane.position, this.plane.quaternion, this.plane.scale);

        if (this.imageUrl) {
            this.image.matrix = imageTransform;
            this.image.matrix.decompose(this.image.position, this.image.quaternion, this.image.scale);
        }

        if (this.videoReadyState) {
            this.setRotation(0, THREE.MathUtils.degToRad(90), 0);
            if (this.video.src.includes('Dyson_VirtualStore_Entrance_HiRes.mp4')) {
                this.setPosition(-2.73, -0.01, 0);
                this.setScale(0.0043, 0.0042, 1);
            } else if (this.video.src.includes('VirtualStore_intro_Desktop_1920x1080.mp4')) {
                this.setPosition(-2.7, -0.01, 0);
                this.setScale(0.0046, 0.0042, 1);
            } else if (this.video.src.includes('VirtualStore_intro_Mobile_1080x1920.mp4')) {
                this.setPosition(-2.8, -0.01, 0);
                this.setScale(0.005, 0.00425, 0);
            }
            console.log("EntranceAnimation video plane");
        }

        if (this.video.src.includes("womens-back-room.mp4")) {

            window.addEventListener('keydown', (e) => {
                if (e.key == 'h') {
                    if (this.gui._hidden) {
                        this.gui.show()
                    } else {
                        this.gui.hide()
                    }
                }
            })

            switch (this.roomId) {
                // 30
                case '6213c4d80b6a1d285d429df1':
                    this.setPosition(3.415, 0.375, -7.152);
                    this.setRotation(0, 5.813, 0);
                    this.setScale(0.1395, 0.1647, 1.450);
                    this.plane.visible = true
                    this.plane.userData.isVideoPlane = true
                    this.video.loop = true
                    this.playActions();
                    break;
                // 31
                case '6213c5e80b6a1d285d429df3':
                    this.setPosition(4.875, 0.1, -9);
                    this.setRotation(0, 0.7, 0);
                    this.setScale(0.061, 0.054, 1.450);
                    this.plane.visible = true
                    this.plane.userData.isVideoPlane = true
                    this.video.loop = true
                    this.playActions();
                    break;
                // 32
                case '6213c6730b6a1d285d429df5':
                    this.setPosition(8.35, 0.15, -9);
                    this.setRotation(0.01, -0.03, 0);
                    this.setScale(0.0525, 0.055, 1);
                    this.plane.visible = true
                    this.plane.userData.isVideoPlane = true
                    this.video.loop = true
                    this.playActions();
                    break;

                //34
                case '6213c7e90b6a1d285d429df9':
                    this.setPosition(-2.680, 0.105, -6.380);
                    this.setRotation(0, 1.670, 0);
                    this.setScale(0.076, 0.100, 1.450);
                    this.plane.visible = true
                    this.plane.userData.isVideoPlane = true
                    this.video.loop = true
                    this.playActions();
                    break;

                //35
                // TODO: FIX POSITIONING
                // case '6213c8900b6a1d285d429dfb':
                //     this.setPosition(-1.5, 0.2, 5.9);
                //     this.setRotation(0, -4.685, 0);
                //     this.setScale(0.0575, 0.083, 1.450);
                //     this.plane.visible = true
                //     this.plane.userData.isVideoPlane = true
                //     this.video.loop = true
                //     this.playActions();
                //     break;

                //38
                case '6213cac10b6a1d285d429e01':
                    this.setPosition(8.030, 0.105, 1.350);
                    this.setRotation(0, -2.492, 0);
                    this.setScale(0.031, 0.041, 1.450);
                    this.plane.visible = true
                    this.plane.userData.isVideoPlane = true
                    this.video.loop = true
                    this.playActions();
                    break;
                //39
                case '6213cb690b6a1d285d429e03':
                    this.setPosition(8.000, 0.105, 0.570);
                    this.setRotation(0, -2.950, 0);
                    this.setScale(0.043, 0.051, 1.450);
                    this.plane.visible = true
                    this.plane.userData.isVideoPlane = true
                    this.video.loop = true
                    this.playActions();
                    break;

                //40
                case '6213cc720b6a1d285d429e05':
                    this.setPosition(4.4, 0.195, 6.1);
                    this.setRotation(0, -1.535, 0);
                    this.setScale(0.0735, 0.0915, 1.450);
                    this.plane.visible = true
                    this.plane.userData.isVideoPlane = true
                    this.video.loop = true
                    this.playActions();
                    break;

                //41
                case '6213ce070b6a1d285d429e18':
                    this.setPosition(7.7, 0.09, 1.75);
                    this.setRotation(-0.045, -0.56, -0.1);
                    this.setScale(0.04435, 0.056, 1.45);
                    this.plane.visible = true
                    this.plane.userData.isVideoPlane = true
                    this.video.loop = true
                    this.playActions();
                    break;

                //42
                case '6213cecd0b6a1d285d429e1a':
                    this.setPosition(6.245, 0.045, -8.860);
                    this.setRotation(0, 0.020, 0);
                    this.setScale(0.039, 0.048, 1.450);
                    this.plane.visible = true
                    this.plane.userData.isVideoPlane = true
                    this.video.loop = true
                    this.playActions();
                    break;

                //43
                case '6213cfd70b6a1d285d429e1e':
                    this.setPosition(8.340, 0.105, -1.730);
                    this.setRotation(-0.010, -1.720, 0);
                    this.setScale(0.065, 0.081, 1.450);
                    this.plane.visible = true
                    this.plane.userData.isVideoPlane = true
                    this.video.loop = true
                    this.playActions();
                    break;
                default:
                    break;
            }
        }
    }
    playActions() {
        this.video.play()
        this.plane.visible = true
        this.plane.userData.shouldBeVisible = true
        if (this.imageUrl) {
            this.image.visible = false
        }
    }

    setPosition(x, y, z) {
        this.plane.position.set(x, y, z);
    }

    setRotation(x, y, z) {
        this.plane.rotation.x = x;
        this.plane.rotation.y = y;
        this.plane.rotation.z = z;
    }

    setScale(x, y, z) {
        this.plane.scale.x = x;
        this.plane.scale.y = y;
        this.plane.scale.z = z;
    }

    play() {
        /*this.video.play();
        this.plane.visible = true;
        if (this.imageUrl) {
            this.image.visible = false;
        }*/
        if (this?.video?.readyState === 4) {
            this.playActions();
        } else {
            this.video.addEventListener("loadeddata", () => {
                this.playActions();
            })
        }

    }

    pause() {
        this.video.pause();
    }

    end() {
        this.plane.visible = false;
        if (this.imageUrl) {
            this.image.visible = true;
        }
        if (this.onVideoEnd) {
            this.onVideoEnd();
        }
    }

    isPlaying() {
        return !this.video.paused;
    }

    isVisible() {
        return this.plane.visible;
    }
}
